import {registerReducer} from './reducer';


registerReducer('globalContext.setGlobalContext', (state, action) => {
	return state.setIn(
		action.appStatePath,
		action.data
	);
});

